import { useStore } from "@store/index";
import { memo, useEffect, useState } from "react";
import { Breadcrumbs } from "@components/commerce/categories/breadcrumbs/Breadcrumbs";
import { getValidPath } from "@lib/utils/breadcrumbsUtility";

type ProductBreadcrumbsProps = {
    // For PDP usage
    articleNumber?: string;
    productName?: string;
    fallbackBreadcrumbs?: string[];
    imageBackgroundColor?: string;
    // For PLP usage
    pathName?: string;
    categories?: string | string[];
    items?: string[];
    // Common props
    locale?: string;
    zIndex?: number;
    marginY?: number | string;
    mb?: number | string;
    pl?: Array<number | string>;
    px?: string | number;
    pt?: object;
};

export const ProductBreadcrumbs = memo(
    ({
        articleNumber,
        productName,
        fallbackBreadcrumbs,
        items,
        locale,
        zIndex,
        marginY,
        mb,
        pl,
        px,
        pt,
    }: ProductBreadcrumbsProps) => {
        const lastVisitedPlp = useStore((state) => state.data.products.lastVisitedPlp);
        const setLastVisitedPlp = useStore((state) => state.setLastVisitedPlp);
        const getPagePathData = useStore((state) => state.getPagePathData);
        const [breadcrumbsData, setBreadcrumbsData] = useState<{ label: string; link: string }[]>(
            []
        );
        const pagePathData = getPagePathData();
        const isPDP = !!articleNumber;

        useEffect(() => {
            let breadcrumbsItems: string[] = [];
            if (isPDP) {
                breadcrumbsItems = lastVisitedPlp
                    ? lastVisitedPlp
                          .split("?")[0]
                          .split("/")
                          .filter((it) => !!it)
                    : fallbackBreadcrumbs;
                breadcrumbsItems = productName
                    ? [...breadcrumbsItems, productName]
                    : breadcrumbsItems;

                setLastVisitedPlp(null);
            } else {
                // PLP breadcrumbs
                breadcrumbsItems = [...items];
            }

            const urlSegments = isPDP ? breadcrumbsItems.slice(0, -1) : breadcrumbsItems;
            const validBreadcrumbsObj = getValidPath(pagePathData, urlSegments, locale);
            setBreadcrumbsData(
                isPDP
                    ? [
                          ...validBreadcrumbsObj,
                          { label: breadcrumbsItems[breadcrumbsItems.length - 1], link: "" },
                      ]
                    : validBreadcrumbsObj
            );
        }, [articleNumber, items]);

        return !!breadcrumbsData?.length ? (
            <Breadcrumbs
                color={"black"}
                items={breadcrumbsData}
                shouldExcludeLastItem={!isPDP}
                zIndex={zIndex}
                marginY={marginY}
                mb={mb}
                pl={pl}
                px={px}
                pt={pt}
            />
        ) : null;
    }
);

ProductBreadcrumbs.displayName = "ProductBreadcrumbs";
